import { ajax } from "@/plugins/api";

export const users = {
    all: data => ajax.get("admin/users", data),
    allBanned: data => ajax.get(`admin/users/banned`, data),
    allReregistered: data => ajax.get(`admin/users/reregistrated`, data),
    get: id => ajax.get(`admin/users/${id}`, { include: "roles.permissions,country,city,sex,ban,reregistration" }),
    update: (id, data, vmId = null, scope = "form") => ajax.put(`users/${id}`, data, vmId, scope),
    auth: id => ajax.get(`authentication/${id}/id`),
    ban: {
        store: (data, vmId = null, scope = "form") => ajax.post("bans?include=user,reason,ticket", data, vmId, scope),
        update: (banId, data) => ajax.put(`bans/${banId}?include=user,reason,ticket`, data),
        destroy: banId => ajax.delete(`bans/${banId}?include=user,reason,ticket`)
    },
    reregistrations: {
        store: (data, vmId = null, scope = "form") =>
            ajax.post("reregistrations?include=user,reason,ticket", data, vmId, scope)
    }
};
